import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PreviousRouteService {
  private _previousUrl: string | null = null;
  private _currentUrl: string | null = null;
  private _lastNavAt = 0;
  private router = inject(Router);

  constructor() {
    this._currentUrl = this.router.url;
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this._previousUrl = this._currentUrl;
        this._currentUrl = e.urlAfterRedirects || e.url;
        this._lastNavAt = Date.now();
      });
  }

  get previousUrl(): string | null { return this._previousUrl; }
  get currentUrl(): string | null { return this._currentUrl; }
  get lastNavAt(): number { return this._lastNavAt; }
}
